export { default } from "./ChallengeEarnedTokenContent";
